"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRef = resolveRef;
function resolveRef(spec, ref) {
    const parts = ref.replace('#/', '').split('/');
    let current = spec;
    for (const part of parts) {
        current = current?.[part];
        if (!current)
            return null;
    }
    return current;
}
//# sourceMappingURL=openapi-types.js.map